import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  associationTable: {
    boxShadow: 'none',
    padding: theme.spacing(2),

    '& form': {
      margin: theme.spacing(5, 0, 0, 0),
      display: 'flex',

      '& tr': {
        marginTop: theme.spacing(8),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        border: `2px solid ${theme.palette.secondary.main}`,
      },

      '& td': {
        width: '100%',
        borderBottom: 'none',
        justifyContent: 'center',
      },
    },
  },

  errorBox: {
    position: 'relative',
  },

  errorMessage: {
    width: '100%',
    position: 'absolute',
    background: theme.palette.secondary.main,
    fontWeight: '700',
  },

}));

export default useStyles;
